import React from 'react';
import { InternalServerError } from '@/routes/500';

interface ErrorHandlerProps {
	children: React.ReactNode;
	fallback?: React.ReactNode;
}

interface ErrorHandlerState {
	hasError: boolean;
	error: Error | null;
}

class ErrorHandler extends React.Component<ErrorHandlerProps, ErrorHandlerState> {
	constructor(props) {
		super(props);
		this.state = { hasError: false, error: null };
	}

	static getDerivedStateFromError(error: Error): {
		readonly hasError: boolean;
		readonly error: Error;
	} {
		// Update state so the next render will show the fallback UI.
		return { hasError: true, error };
	}

	componentDidCatch(error: Error, info): void {
		console.log('ErrorHandler in catch', { error, stack: info.componentStack });
	}

	render(): React.ReactNode {
		if (this.state.hasError) {
			return <InternalServerError error={this.state.error?.message} description={this.state.error?.stack} />;
		}
		return this.props.children;
	}
}

export default ErrorHandler;
